import { createContext } from 'react';
import { styled } from '../../themeCustomink';
export var ChipContainer = styled('span')({
    position: 'absolute',
    top: '16px',
    left: '16px',
});
export var CardContext = createContext('medium');
//# sourceMappingURL=utils.js.map